<div class="container-fluid">
  <div class="row no-gutters">
    <div class="col-12 cols">
      <!-- Left Section -->
      <div class="col-md-6  col-sm-12  left-section">
        <div class="logo-container">
          <ul class="d-flex" style="list-style: none;">
            <li> <img    src="../../assets/images/grammarin-logo/grammarin-logo.svg" [routerLink]="['/']"
                alt="logo-main" class="img-fluid" class="logo">
                <!-- (click)="navigateToHome()"  -->
              </li>
          </ul>
        </div>
        <div class="login-form">
          <h3 style="font-size: 28px ; font-weight: 600;">Welcome Back!</h3>
          <p style="line-height: 24px">Enter your username or password to continue.</p> <span
            class="alert alert-danger mb-2" id="dangerAlert2" style="display: none; "></span> 
            
            <span
            class="alert alert-danger mb-2" id="dangerAlert" style="display: none; ">
          </span>
            <!-- <p class="alert alert-danger mb-2" *ngIf="got_recpatcha"  > <i
              class="fa fa-times-circle matr ml-1" aria-hidden="true" ></i> {{ recaptcha_message }} </p> -->
          <form method="" action="" class="mb-0" [formGroup]="logins">
            <div class="form-group">
              <label for="email" style="font-weight: 600 ;">Email</label>
              <input id="login_email" name="login_email" ngDefaultControl formControlName="login_email" type="email"
                class="form-control " name="login_email" value="" placeholder="Example@email.com"
                onfocus="this.placeholder=''" onblur="this.placeholder='Example@email.com'" required />
            </div>
            <div class="form-group">
              <label for="password" style="font-weight: 600 ;">Password</label>
              <input id="login_password" value="" name="login_password" ngDefaultControl
                formControlName="login_password" type="password" [type]="passwordFieldType"
                onfocus="this.placeholder=''" onblur="this.placeholder='At least 8 characters'" class="form-control"
                name="login_password" placeholder="At least 8 characters" required />
            </div> <span style="
                  color: #000000;
                  float: right;
                  margin-bottom: -30px;
                  padding-left: 20px;
                  margin-top: -45px;
                  margin-right: 20px;
                  cursor: pointer;
                ">
              <i class="eye-icon" (click)="togglePasswordVisibility()" [ngClass]="{
                    'fa fa-fw fa-eye': passwordFieldType === 'password',
                    'fas fa-eye-slash': passwordFieldType === 'text'
                  }"></i>
            </span>
            <div class="form-group text-right"> <a routerLink="/forgot-password" class="text-dark"
              [routerLink]="['/forgot-password']" style="cursor: pointer;">Forgot Password?</a> </div>
        
              <div id="recaptcha-container"  data-size="compact" data-theme="light" style="display: flex; justify-content: center;  margin-top: 15px;"></div>
        
           
                <!-- (click)="navigateTosiforgot()"  -->
            <div class="form-group">
              <button type="submit" class="btn btn-dark submit btn-block"
                style="  width: 388pxpx;height: 52pxpx !important;" (click)="handleButtonClick()">Sign in</button>
            </div>
          </form>
          <div class="or-separator"><span>Or</span></div>
          <div class="social-buttons">
            <button class="btn btn-block mb-2 butn1 " id="google" (click)="googleLogin()"> <img
                src="../../assets/images/signin-signup/google.svg" alt="Google"><span>Sign in with Google</span>
            </button>
            <!-- <button class="btn btn-block butn1" id="fb">
                    <img src="../../assets/images/signin-signup/fb.svg" alt="Facebook">Sign in with Facebook
                </button> -->
          </div>
          <p class="text-center mt-4">Don't you have an account? <a [routerLink]="['/signup']"
              style="cursor: pointer; color: #08BA9C;"> Sign up </a></p>
              <!-- (click)="navigateTosignup()" -->
        </div>
      </div>
      <!-- Right Section -->
      <div class="col-md-6 col-sm-12 right-section">
        <div class="marginSection">
          <h4>Login</h4>
          <p>To keep connected with us please login with your personal information
            <br> by email address and password
          </p> <img src="../../assets/images/editorimages/editor-new-logo.png" alt="Illustration"
            class="IllustrationImage img-fluid">
        </div>
      </div>
    </div>
  </div>
</div>
  <!-- code for validation  -->
  <div
  *ngIf="error"
  class="backdrop"
  style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
</div>

<!-- Your main content div -->
<div
  *ngIf="error"
  class="content-div"
  style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);          width: 468px;
  height: 360px;
   background-color: white; z-index: 1010; border-radius: 4px; border: 1px solid  white ;">

  <div class="text-center" style="    margin-top: 9%;">
    <img src="/assets/images/paraphrasing tool/alert.svg"/>

    <div style="       width: 440px;
    height: 64px;
    margin-left: 16px;">
     <p
      class="error mt-4"
      style="   font-size: 20px;
      font-weight: 500;
      line-height: 33.89px;
  ">
      {{ errorAlerts }}
    </p>
    </div>

    <button
      class="mt-5 butn-alert"
      (click)="closeErrorDiv()">Ok</button>
  </div>
</div>


<div
*ngIf="success"
class="backdrop"
style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
</div>

<!-- Your main content div -->
<div
*ngIf="success"
class="content-div"
style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);           width: 468px;
height: 360px; background-color: white; z-index: 1010; border-radius: 4px; border: 1px solid white;">

<div class="text-center" style="    margin-top: 9%;">
  <img src="/assets/images/paraphrasing tool/success.svg" style="width: 138px; height: 138px;"/>

  <p
  *ngIf="success"
    class="error mt-3 content-div-p"
    style="   font-size: 24px;
    font-weight: 500;
    line-height: 33.89px
;
;">
    {{ successAlert}}
  </p>

  <!-- <button
    class="mt-4 butn-alert"
    (click)="closeErrorDiv()">Ok</button> -->
</div>
</div>
<!-- code for validation  -->
